import { useQuery } from '@tanstack/react-query';

import { api } from '@/shared/lib/apiClient';
import { useLocale } from './useLocale';

export function useCmsNavigation() {
  const locale = useLocale();
  return useQuery({
    queryKey: ['cms-navigation', locale],
    queryFn: ({ signal }) => api.pageSections.navigation(signal),
    staleTime: 30_000,
  });
}
